import React from 'react';
import { styled } from '@mui/material/styles';
import { Card } from '@mui/material';

const HolographicCard = styled(Card)(({ theme }) => ({
  position: 'relative',
  overflow: 'hidden',
  background: 'rgba(255, 255, 255, 0.03)',
  backdropFilter: 'blur(10px)',
  border: '1px solid rgba(255, 255, 255, 0.1)',
  borderRadius: '12px',
  boxShadow: `0 8px 32px 0 rgba(31, 38, 135, 0.15)`,
  transition: 'all 0.3s ease',
  
  '&:before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: `linear-gradient(
      135deg,
      rgba(25, 118, 210, 0.2) 0%,
      rgba(76, 175, 80, 0.2) 50%,
      rgba(156, 39, 176, 0.2) 100%
    )`,
    zIndex: -1,
    opacity: 0.7,
    transition: 'opacity 0.3s ease'
  },
  
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: `0 12px 40px 0 rgba(31, 38, 135, 0.25)`,
    
    '&:before': {
      opacity: 0.9,
      animation: 'holographicEffect 8s infinite linear'
    }
  },

  '@keyframes holographicEffect': {
    '0%': { backgroundPosition: '0% 50%' },
    '50%': { backgroundPosition: '100% 50%' },
    '100%': { backgroundPosition: '0% 50%' }
  }
}));

export default HolographicCard;